export enum BankRequisitesStatus {
  REJECTED = 'REJECTED',
  UNVERIFIED = 'UNVERIFIED',
  VERIFIED = 'VERIFIED',
}
